import { Outlet } from 'react-router-dom';
import AppHeader from '../components/appHeader';
import React from 'react';
import { useRefreshTokenBeforeExpiry } from './refreshTokenHelper';

const Root: React.FC = () => {
  // const [sideBarOpen, setSideBarOpen] =
  //   React.useState(false);

  // const handleToggleDrawer = () => {
  //   setSideBarOpen(!sideBarOpen);
  // };
  useRefreshTokenBeforeExpiry();

  return (
    <>
      <AppHeader
      // toggleDrawer={() => handleToggleDrawer()}
      />
      <Outlet />
    </>
  );
};

export default Root;
